import { render, staticRenderFns } from "./GroupPublisherSelection.vue?vue&type=template&id=09a57557&scoped=true"
import script from "./GroupPublisherSelection.vue?vue&type=script&lang=js"
export * from "./GroupPublisherSelection.vue?vue&type=script&lang=js"
import style0 from "./GroupPublisherSelection.vue?vue&type=style&index=0&id=09a57557&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a57557",
  null
  
)

export default component.exports